var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotasDevolucao(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.695,
    height: 17.312,
    viewBox: "0 0 12.695 17.312",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "xml",
    transform: "translate(-36 -8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3056",
    "data-name": "Grupo 3056",
    transform: "translate(36 8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2275",
    "data-name": "Caminho 2275",
    d: "M50.387,108.616a.578.578,0,0,0,.577-.577v-3.462a.578.578,0,0,0-.577-.577h-9.81a.578.578,0,0,0-.577.577v3.462a.578.578,0,0,0,.577.577Z",
    transform: "translate(-40 -97.075)",
    fill: "#64c2c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2276",
    "data-name": "Caminho 2276",
    d: "M58.964,8h-9.81A1.155,1.155,0,0,0,48,9.154v5.194h.577V9.154a.578.578,0,0,1,.577-.577h9.81a.578.578,0,0,1,.577.577V21.2a.584.584,0,0,1,0,.07H56.944a.867.867,0,0,0-.866.866V24.73a.585.585,0,0,1-.07,0H49.154a.578.578,0,0,1-.577-.577V20.118H48v4.039a1.155,1.155,0,0,0,1.154,1.154h6.855a1.146,1.146,0,0,0,.816-.338l2.955-2.955a1.147,1.147,0,0,0,.338-.816V9.154A1.155,1.155,0,0,0,58.964,8Z",
    transform: "translate(-47.423 -8)",
    fill: "#64c2c8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "back-left-curved-arrow",
    transform: "translate(3 -126.988)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2277",
    "data-name": "Caminho 2277",
    d: "M1.252,134.469a.3.3,0,0,0-.42,0l-.744.735a.3.3,0,0,0,0,.42l.745.754a.3.3,0,0,0,.422-.417l-.241-.244H3.435a.913.913,0,0,1,.912.912v.024a.906.906,0,0,1-.267.645.3.3,0,1,0,.42.42,1.5,1.5,0,0,0,.441-1.065v-.024a1.506,1.506,0,0,0-1.506-1.506H1.016l.233-.23A.3.3,0,0,0,1.252,134.469Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotasDevolucao);
export default __webpack_public_path__ + "static/media/notasDevolucao.a964a366c8f18657df84440d26720307.svg";
export { ForwardRef as ReactComponent };